// extracted by mini-css-extract-plugin
export default {"rightbordershadow":"PaidStaffings_rightbordershadow__ssjl+"};